export default "__VITE_ASSET__CD5cQq3v__"